import { render, staticRenderFns } from "./ProjectDetailCard.vue?vue&type=template&id=9f9b3c8a&scoped=true"
import script from "./ProjectDetailCard.vue?vue&type=script&lang=js"
export * from "./ProjectDetailCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailCard.vue?vue&type=style&index=0&id=9f9b3c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9b3c8a",
  null
  
)

export default component.exports